export default __webpack_public_path__ + "static/nestjs-8cc42ce999a70203a1c22175f7a6bc52.svg";